module.exports = __webpack_public_path__ + "static/media/CaixaLivre2.c00d60d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCaixaLivre/CaixaLivre2.png
// module id = 2045
// module chunks = 0